import { Route, Routes, useNavigate } from 'react-router-dom';
import { AboutUs, AgrisenseMobile, HomePage, KonektavLitePos, LegalPage, WakaPayroll, WhyChooseUs } from './pages';
import { Main } from './layouts';

function App() {
  const navigate = useNavigate();
  return (
    <Routes navigate={navigate}>
      <Route path="/" element={<Main />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/konektav-lite-pos" element={<KonektavLitePos />} />
        <Route path="/waka-payroll" element={<WakaPayroll />} />
        <Route path="/agrisense-mobile" element={<AgrisenseMobile />} />
        <Route path="/WhyChooseUs" element={<WhyChooseUs/>}/>
        <Route path="/AboutUs" element={<AboutUs/>}/>
        <Route path="/terms-and-conditions" element={<LegalPage type="terms-and-conditions" />}/>
        <Route path="/privacy-policy" element={<LegalPage type="privacy-policy" />}/>
        <Route path="/return-and-refund-policy" element={<LegalPage type="return-and-refund-policy" />}/>
        <Route path="/dispute-resolution-policy" element={<LegalPage type="dispute-resolution-policy" />}/>
      </Route>
    </Routes>
  );
}

export default App;
